let configCore = {
    admin_application_instance_id: '013aee58-14f6-4f74-ada7-e95e8eadfcf9',
    admin_application_id: '81cb0181-348b-4990-8fc4-8bcfd0f3c763',
    routesNoAuth: []
}
export default configCore;